import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { ApolloConsumer } from 'react-apollo'

import { DOWNLOAD_FILE } from '../../queries'

import { Row, Item, Sup, LinkContainer, Messages, Reminder, Complaint } from './styles'
import { Order } from '../../components/Icons'

class InvoiceTableRow extends Component {

  render() {
    let {
      headers,
      item
    } = this.props

    return (
      <Row key={item.id} noPadding>
        <Item>
          <Sup>{headers[0]}</Sup>
          {typeof item.one === 'string' ? item.one : item.one}
        </Item>
        <Item>
          <Sup>{headers[1]}</Sup>
          {typeof item.two === 'string' ? item.two : item.two}
        </Item>
        <Item>
          <Sup>{headers[2]}</Sup>
          {typeof item.three === 'string' ? item.three : item.three}
        </Item>
        <Item>
          <Sup>{headers[3]}</Sup>
          € {parseFloat(item.four).toFixed(2)}
        </Item>
        <Item>
          <Sup>{headers[4]}</Sup>
          {item.five.map((file, index) => {
            return (
              <ApolloConsumer key={index}>
                {client => (
                  <LinkContainer>
                    <a id={`download-${item.one}`} style={{ display: 'none' }} download={file}>&nbsp;</a>
                    <a
                      onClick={async () => {
                        const { data } = await client.query({
                          query: DOWNLOAD_FILE,
                          variables: { data: { file: file, path: 'Facturen' } }
                        });
                        const link = document.getElementById(`download-${item.one}`)
                        link.href = `data:application/octet-stream;base64,${data.downloadFile}`
                        link.click()
                      }}
                    >
                      <Order size="" /> Factuur
                    </a>
                  </LinkContainer>
                )}
              </ApolloConsumer>
            )
          })}
        </Item>
        {(item.complaint || item.reminder) ? (
          <Messages>
            Meldingen: {item.reminder ? (<Reminder>Maningstatus</Reminder>) : null} {item.complaint ? (<Complaint>Klacht in behandeling</Complaint>) : null}
            <span>Vragen? Neem <Link to="/contact">contact</Link> op.</span>
          </Messages>
        ) : null}
      </Row>
    )
  }
}

export default withRouter(InvoiceTableRow)



// WEBPACK FOOTER //
// ./src/components/InvoiceTableRow/index.js